<template>
  <div class="Ride">
    <div
      :class="{
        'ride-container': true,
        flipped,
        [selectedRide.id]: true
      }"
    >
      <img
        :style="{
          transform: 'scaleX(' + (flipped ? 1 : -1) * direction + ')'
        }"
        :src="selectedRide.imgAlt"
        class="ride ride-alt"
        v-if="$store.state.rides.inAltState && selectedRide.imgAlt"
        @click="$store.dispatch('toggleRideInAltState')"
      />
      <img
        :style="{
          transform: 'scaleX(' + (flipped ? 1 : -1) * direction + ')',
          'transform-origin': '50% 70%'
        }"
        :src="selectedRide.img"
        class="ride"
        v-else
        @click="$store.dispatch('toggleRideInAltState')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Ride",
  props: {
    flipped: null
  },
  computed: {
    direction() {
      return this.$store.state.geolocation.direction > 0 ? +1 : -1;
    },
    selectedRide() {
      return this.$store.getters.selectedRide;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/constants/_variables.scss";

.ride-container {
  img {
    max-height: 100px;
  }

  &.truck {
    transform: translate(0px, -30px);

    @media (max-width: $mobile-screen-width) {
      transform: translate(0px, -25px);
    }

    &.flipped {
      transform: rotate(-180deg) translate(0px, -30px);

      @media (max-width: $mobile-screen-width) {
        transform: rotate(-180deg) translate(0px, -25px);
      }
    }
  }

  &.bug {
    transform: translate(0px, -15px);

    &.flipped {
      transform: rotate(-180deg) translate(0px, -30px);
    }
  }

  &.vw-bus {
    transform: translate(0px, -20px);

    &.flipped {
      transform: rotate(-180deg) translate(0px, -30px);
    }
  }
}

.ride {
  max-width: 100%;
}
</style>
